var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "pipeline-form" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "input title-input" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("Name")]),
          _vm._v(" "),
          _c("a-input", {
            staticClass: "classic-new-input",
            attrs: { placeholder: _vm.$t("task.taskNumber") },
            model: {
              value: _vm.form.title,
              callback: function ($$v) {
                _vm.$set(_vm.form, "title", $$v)
              },
              expression: "form.title",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input priority-input" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("Status")]),
          _vm._v(" "),
          _c("a-select", {
            staticClass: "classic-new-select",
            attrs: { options: _vm.options },
            model: {
              value: _vm.form.type,
              callback: function ($$v) {
                _vm.$set(_vm.form, "type", $$v)
              },
              expression: "form.type",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pipeline-rules" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Rules")]),
      _vm._v(" "),
      _c("div", { staticClass: "rules-list" }, [
        _c("div", { staticClass: "rule-item" }, [
          _c("div", [
            _c("div", { staticClass: "rule-item-title" }, [
              _c("div", { staticClass: "material-icons" }, [_vm._v("comment")]),
              _vm._v(
                "\n                        Comments Write\n                    "
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }